<div>
	@if (!removeDivider()) {
	<lib-divider class="push-top-md push-bottom-md"></lib-divider>
	}

	<div libFlexRow [class.push-top]="removeDivider()">
		@if (isInDialog() && !isMobileView()) {
		<div libFlexColumn libFlexFill></div>
		}
		<div libFlexColumn [libFlexSize]="isMobileView() || useFullSize() ? 'full' : undefined">
			<lib-button
				(click)="handleSave()"
				[buttonSize]="'large'"
				[buttonSize]="useFullSize() ? 'full' : undefined"
				[buttonType]="buttonType()"
				[disabledButtonType]="disabledButtonType()"
				[disabled]="isDisabled()"
				[libTooltip]="!isDisabled() ? undefined : 'Form is not filled in correctly'"
				><span>{{ title() ?? 'Save' }}</span></lib-button
			>
		</div>
	</div>

	@if (errorMessage(); as errorMessage) {
	<div class="push-top">
		<lib-message [type]="'error'">{{ errorMessage }}</lib-message>
	</div>
	}
</div>
